var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tag',{class:{'need-complate':_vm.homeworkType==1,'practice':_vm.homeworkType==2},attrs:{"size":"mini"}},[_vm._v(_vm._s(_vm.homeworkType==1?'要求完成':'仅供练习'))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df3e0d08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/paginationCells/homeworkTypeCell.vue
// module id = kBxL
// module chunks = 0